var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIbmDndSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .ibm-2{fill:#8cd211}.ibm-2,.cls-3,.cls-4{fill-rule:evenodd}.cls-3{fill:#20343e}.cls-4{fill:#5aaafa}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_sync_ibm_40",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M21.4 16.382l-5.584 2.925v-5.79l5.584-2.953z",
    className: "ibm-2",
    transform: "translate(4.625 6.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M10.7 19.493l-5.14-2.684v-5.79L10.7 13.7z",
    className: "cls-3",
    transform: "translate(8.825 5.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    d: "M24.975 5.837l-5.408-2.8-1.8.924L23.056 6.7v9.82l1.919-.987z",
    className: "cls-4",
    transform: "translate(3.825 9.258)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    d: "M14.923 21.073l-6.028 3.163L.03 19.61 0 22.355l8.835 4.565 6.088-3.133z",
    className: "ibm-2",
    transform: "translate(11.1 2.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    d: "M11.287 1.282L8.835 0 .03 4.6l-.03 6 2.393 1.222V5.938z",
    className: "cls-3",
    transform: "translate(11.1 10.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    d: "M11.8 10.683l-4.7-2.45 5.349-2.775L17.123 7.9z",
    className: "cls-4",
    transform: "translate(8.191 8.265)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbmDndSmall);
export default __webpack_public_path__ + "static/media/ibm-dnd-small.6b3f92fa978eef36fdde20e545eff939.svg";
export { ForwardRef as ReactComponent };